<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="text-h2">Dashboard</h1>
        <p>coming soon, ya bastud</p>
      </v-col>
    </v-row>
  </v-container>
</template>